import { useStaticQuery, graphql } from "gatsby";

export const GetHomeServiceData = () => {
  const data = useStaticQuery(graphql`
    query {
      allWpService {
        nodes {
          technologiesData {
            nodes {
              title
              slug
              titleSlogan
              icon
              urlSlug {
                nodes {
                  slug
                }
              }
            }
          }
        }
      }
    }
  `);
  
  return data.allWpService.nodes;
};
